import { default as string } from '@poppinss/string'
import type { ModelColumnOptions } from '@adonisjs/lucid/types/model'
import type { ResourcefulModel } from '@nhtio/lucid-resourceful/types'

export const resolveModelDisplayColumn = (model: ResourcefulModel): string => {
  /*
     |--------------------------------------------------------------------------
     | If the model has a defined display column, use that
     |--------------------------------------------------------------------------
     */
  if (
    'string' === typeof model.$resourcefulTitleColumn &&
    model.$resourcefulTitleColumn.trim().length > 0
  ) {
    const found = model.$columnsDefinitions.get(model.$resourcefulTitleColumn)
    if (found) {
      return found.columnName
    }
    return model.$resourcefulTitleColumn
  }
  /*
     |--------------------------------------------------------------------------
     | Check for common display fields in the properties which are matched to
     | database columns
     |--------------------------------------------------------------------------
     */
  const candidates = ['name', 'title', 'label', 'display', 'displayName', 'fullName', 'userName']
  const potentials = new Map<string, ModelColumnOptions>()
  model.$columnsDefinitions.forEach((columnOptions, attribute) => {
    potentials.set(attribute, columnOptions)
    potentials.set(string.camelCase(attribute), columnOptions)
    potentials.set(columnOptions.columnName, columnOptions)
    potentials.set(string.camelCase(columnOptions.columnName), columnOptions)
  })
  for (const candidate of candidates) {
    let found = potentials.get(candidate)
    if (found) {
      return found.columnName
    }
    found = potentials.get(candidate.toLowerCase())
    if (found) {
      return found.columnName
    }
    found = potentials.get(string.snakeCase(candidate))
    if (found) {
      return found.columnName
    }
  }
  /*
     |--------------------------------------------------------------------------
     | Fallback to the primary key
     |--------------------------------------------------------------------------
     */
  return model.primaryKey
}
